import React from 'react';
import { contactEmail } from '../data/content';
export function SiteFooter() {
  return <footer className="bg-night pb-28 pt-14" data-id="element-199" data-mp="3r7punplj411c">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-200" data-mp="3r8rfumw9e3ws">
        <div className="grid gap-8 border-b border-line pb-10 lg:grid-cols-[1.2fr_0.8fr]" data-id="element-201" data-mp="3mh1206y44y0m">
          <div data-id="element-202" data-mp="3hipx8amoddp9">
            <p className="font-display text-2xl font-bold uppercase tracking-tight text-white" data-id="element-203" data-mp="3hj7yjlo72i41">
              The Total Academy System&trade;
            </p>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-white/50" data-id="element-204" data-mp="3dei4m2d3jdlr">
              The complete 11v11 curriculum for professional football academies.
              Because coaching shouldn&rsquo;t cost you every evening of the
              week.
            </p>
          </div>
          <ul className="flex flex-wrap items-start gap-x-8 gap-y-3 text-xs font-semibold uppercase tracking-[0.14em] text-white/50 lg:justify-end" data-id="element-205" data-mp="2ylop4gxtqxh3">
            <li data-id="element-206" data-mp="wrz5dnleavc7">
              <a href={`mailto:${contactEmail}`} className="transition-colors duration-150 ease-smooth hover:text-acid" data-id="element-207" data-mp="wtijp8nhqwbc">
                {contactEmail}
              </a>
            </li>
            <li data-id="element-208" data-mp="1anvhrktdy4b2">
              <a href="#order" className="transition-colors duration-150 ease-smooth hover:text-acid" data-id="element-209" data-mp="vspayvmgu1go">
                Get the system
              </a>
            </li>
          </ul>
        </div>
        <p className="pt-6 text-[11px] uppercase tracking-[0.16em] text-white/30" data-id="element-210" data-mp="1oio1kvgb66ng">
          &copy; Total Academy Systems 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}